module.exports = __webpack_public_path__ + "static/media/LogoWhite.695c763d.svg";